import { render, staticRenderFns } from "./SnowBox.vue?vue&type=template&id=52190850&"
import script from "./SnowBox.vue?vue&type=script&lang=ts&"
export * from "./SnowBox.vue?vue&type=script&lang=ts&"
import style0 from "./SnowBox.vue?vue&type=style&index=0&id=52190850&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports